import { render, staticRenderFns } from "./recruitCenter.vue?vue&type=template&id=24386dbe&"
import script from "./recruitCenter.vue?vue&type=script&lang=js&"
export * from "./recruitCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports